import type { TripStatus } from '@raahi/shared';

const COPY: Record<TripStatus, { label: string; tone: string }> = {
  requested: { label: 'Requested', tone: 'bg-slate-100 text-slate-700' },
  searching: { label: 'Searching', tone: 'bg-amber-100 text-amber-800' },
  assigned: { label: 'Assigned', tone: 'bg-blue-100 text-blue-800' },
  arriving: { label: 'Arriving', tone: 'bg-blue-100 text-blue-800' },
  arrived: { label: 'Arrived', tone: 'bg-emerald-100 text-emerald-800' },
  in_progress: { label: 'On trip', tone: 'bg-emerald-100 text-emerald-800' },
  completed: { label: 'Completed', tone: 'bg-slate-100 text-slate-700' },
  cancelled: { label: 'Cancelled', tone: 'bg-rose-100 text-rose-800' },
};

export function StatusPill({ status }: { status: TripStatus }) {
  const c = COPY[status];
  return <span className={'pill ' + c.tone}>{c.label}</span>;
}

export function DriverStatusPill({ status, approved }: { status: string; approved: boolean }) {
  if (!approved) return <span className="pill bg-amber-100 text-amber-800">Pending approval</span>;
  if (status === 'online') return <span className="pill bg-emerald-100 text-emerald-800">Online</span>;
  if (status === 'on_trip') return <span className="pill bg-blue-100 text-blue-800">On trip</span>;
  return <span className="pill bg-slate-100 text-slate-700">Offline</span>;
}
